import { render } from "./AddNewRestaurant.vue?vue&type=template&id=40c1e8fe&scoped=true"
import script from "./AddNewRestaurant.vue?vue&type=script&lang=js"
export * from "./AddNewRestaurant.vue?vue&type=script&lang=js"

import "./AddNewRestaurant.vue?vue&type=style&index=0&id=40c1e8fe&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c1e8fe"]])

export default __exports__